import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
export function blockNumberReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var current = state[action.chainId];

  if (!current || action.blockNumber > current) {
    return Object.assign(Object.assign({}, state), _defineProperty({}, action.chainId, action.blockNumber));
  }

  return state;
}